<template>
  <div style="width:100%;float:left;position:relative;">
    <div style="width:100%;float:left;">
      <CCard>
        <CCardBody>
          <h5 style="width:100%;float:left;text-align: center;">Click on row to view order/pdf</h5>
          <table class="table" v-if="data">
            <thead>
              <tr>
                <th></th>
                <th>Log#</th>
                <th>CC#</th>
                <th>Program</th>
                <th>Styles</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr style="cursor:pointer;" v-for="(val, index) in data" @click="orderClicked(val, index)">
                <td>
                  <CIcon v-if="index === currentIndex" name="cil-arrow-right"/>
                </td>
                <td>{{val.as400_log_number}}</td>
                <td>{{val.cc_number}}</td>
                <td>{{val.order_items[0].program_info.program_name}}</td>
                <td>{{val.order_items.length}}</td>
                <td>{{val.as400_status}}</td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
      </CCard>
    </div>
  	<!-- <div style="width:100%;float:left;" v-if="data" v-for="(val, index) in data">
  		<CCard>
        <CCardHeader @click="val.collapsed = !val.collapsed">
          PDF Order {{index + 1}}
          <div class="card-header-actions">
            <CLink class="card-header-action btn-minimize">
              <CIcon :name="`cil-chevron-${val.collapsed ? 'bottom' : 'top'}`"/>
            </CLink>
          </div>
        </CCardHeader>
        <CCollapse :show="val.collapsed" :duration="400">
          <CCardBody v-if="val.collapsed">
          	<pdf-view :form="val" :type="index"></pdf-view>
          </CCardBody>
        </CCollapse>
      </CCard>
		</div> -->
    <div style="width:100%;float:left;">
      <CCard>
        <CCardBody>
          <div style="width:100%;" v-if="current">
            <div class="col-12 float-left mb-3" v-if="$store.state.user.user_type !== 'rep'">
              <order-cc :group="current"></order-cc>
            </div>
            <!-- <div style="width:100%;float:left;margin-bottom:15px;"> -->
            <div class="col-sm-12 text-center float-left" v-if="configureButtons(current) && $store.state.user.user_type !== 'rep'">
              <CButton size="sm" class="m-1 float-left" color="success" @click="generate('artpacks', current)" v-if="configureButtonType(current, 'artpacks')">Generate Artpack(s)</CButton>
              <CButton size="sm" class="m-1 float-left" color="success" @click="generate('escapes', current)">Generate Escape</CButton>
              <CButton size="sm" class="m-1 float-left" color="info" @click="generate('components', current)" v-if="configureButtonType(current, 'components')">Generate Component(s)</CButton>
              <CButton size="sm" class="m-1 float-left" color="danger" @click="generate('embroideries', current)" v-if="configureButtonType(current, 'embroideries')">Generate Embroidery</CButton>
              <CButton size="sm" class="m-1 float-left" color="warning" @click="generate('heat_seals', current)" v-if="configureButtonType(current, 'heat_seals')">Generate Heat Seal(s)</CButton>

              <spacer />
            </div>
            <div style="width:100%;" v-if="$store.state.user.user_type !== 'csr'">
              <!-- <pdf-view :form="current" :type="currentIndex"></pdf-view> -->
            </div>
            <div style="width:100%;" v-else>
              <adobe-pdf-viewer v-if="current.original_pdf_id" :otherClass="'in_pdf_order'" :order_group="currentPdf" :pdf_type="'current'" :allowEdit="true"></adobe-pdf-viewer>
              <!-- <pdf-view v-else :form="current" :type="currentIndex"></pdf-view> -->


            </div>
          </div>
          <small-loader v-else-if="currentLoading"></small-loader>
        </CCardBody>
      </CCard>
    </div>

    <CModal
      title="Generate Request"
      :show.sync="generateModal"
      size="xl">
      <div style="width:100%;float:left;" v-if="generateGroup">
        <component-request v-if="generateType === 'components'" @submitted="submitChange" :group="generateGroup" :newData="form"></component-request>
        <escape-request v-if="generateType === 'escapes'" :group="generateGroup" :newData="form"></escape-request>
        <artpack-request v-if="generateType === 'artpacks'" :group="generateGroup" :newData="form"></artpack-request>
        <embroidery-request v-if="generateType === 'embroideries'" :group="generateGroup" :newData="form"></embroidery-request>
        <heat-seal-request v-if="generateType === 'heat_seals'" :group="generateGroup" :newData="form"></heat-seal-request>
      </div>
    </CModal>
  </div>
</template>
<script>
import PdfView from './pdf_view'
import AdobePdfViewer from './adobe_pdf_viewer'
import EscapeRequest from './../flow/escape_request'
import ArtpackRequest from './../flow/artpack_request'
import EmbroideryRequest from './../flow/embroidery_request'
import ComponentRequest from './../flow/component_request'
import HeatSealRequest from './../flow/heat_seal_request'
const OrderCc = () => import('./../orders/order_cc.vue')
var methods = {}

methods.getOrder = function () {
  this.currentLoading = true
  const postData = {
    order_id: this.order_id
  }
  axios.post(this.$apiAdress + '/api/orders/getOrderDisplay?token='+localStorage.getItem('api_token'), postData)
  .then(response => {
    console.log('pdf orderrrrr')
    console.log(response)
    var arr = []
    // this.collapsed = arr
    this.form = response.data
    
    this.data = this.getPdfData(response.data)
    this.current = this.data[0]
    this.currentIndex = 0
    this.currentLoading = false
  }).catch(e => {
    console.log(e)
    if (e.response.status === 422) {
      this.$router.push('/login')
    }
  })
}

methods.submitChange = function () {
  this.generateModal = false
  this.generateGroup = null
  this.generateType = ''
}

methods.generate = function (type, val) {
  this.generateType = type
  this.generateGroup = val
  this.generateModal = true
}

methods.configureButtonType = function (value, type) {
  var t = false
  value.order_items.forEach(function (item) {
    console.log(item)
    item.order_item_locations.forEach(function (location) {
      if (location.decoration.req_type === 'artpacks' || location.new_decoration) {
        if (type !== 'artpacks') {
          if (location.technique.type === type) {
            t = true
          }
        } else {
          if (location.new_decoration) {
            t = true
          }
        }
      }
    })
  })
  return t
}

methods.configureButtons = function (value) {
  console.log('configure buttons')
  console.log(value)
  var t = false
  if (value.cc_number) {
    t = true
    // value.order_items.forEach(function (item) {
    //   console.log(item)
    //   item.order_item_locations.forEach(function (location) {
    //     if (location.decoration.req_type === 'artpacks' || location.new_decoration) {
    //       t = true
    //     }
    //   })
    // })
  }
  return t
}

methods.orderClicked = function (order, index) {
  this.currentLoading = true
  this.current = null
  this.currentIndex = null
  var that = this
  setTimeout(function () {
    that.current = order
    that.currentIndex = index
    that.currentLoading = false
  }, 1000)
}

methods.addPdf = function (pdf) {
  console.log('pdf set')
  console.log(pdf)
  this.pdfs.push(pdf)
  // if (this.pdfs.length === this.data.length) {
    console.log('we set')
    const postData = {
      order_id: this.order_id,
      pdfs: this.pdfs
    }
    console.log(postData)
    // if (!this.form.pdf_sent) {
      axios.post(this.$apiAdress + '/api/orders/sendPdf?token=' + localStorage.getItem('api_token'), postData).then(res => {
        console.log(res)
        this.$emit('pdf-sent')
      }).catch(e => {
        console.log(e)
      })
    // }
  // }
}

methods.getPdfData = function (data) {
  var obj = {}
  var o = {}
  var arr = []
  data.order_groups.forEach(function (val) {
    var obj = {}
    for (var key in data) {
      if (key != 'order_groups') {
        obj[key] = data[key]
      }
    }
    for (var key in val) {
      obj[key] = val[key]
    }
    obj.collapsed = false
    arr.push(obj)
  })
  console.log('pdf data')
  console.log(arr)
  // data.order_items.forEach(function (val) {
  // 	var name = val.program_name
  // 	val.order_item_locations.forEach(function (loc) {
  // 		name = name + '_' + loc.location.location_code + '_' + loc.file
  // 	})
  // 	name = name + '_' + val.ship_date
  // 	if (!obj[name]) {
  // 		obj[name] = {}
  		// for (var key in data) {
    //     if (key != 'order_items') {
    //       obj[name][key] = data[key]
    //     }
    //   }
  //     obj[name].ship_date = val.ship_date
  //     obj[name].event_date = val.event_date
  //     obj[name].program_name = val.program_name
  //   	obj[name].order_items = []
  //   	obj[name].collapsed = false
  // 	}
  // 	obj[name].order_items.push(val)
  	// return obj
  	// var name = 
   //  if (!o[val.program_name]) {
   //    o[val.program_name] = {}
      // for (var key in data) {
      //   if (key != 'order_items') {
      //     o[val.program_name][key] = data[key]
      //   }
      // }
   //    o[val.program_name].order_items = []
   //  }
   //  o[val.program_name].order_items.push(val)
  // })
  console.log(obj)
  // var arr = []
  // for (var key in obj) {
  // 	arr.push(obj[key])
  // }
  console.log(arr)
  // return obj
  return arr
}

export default {
    // ===Component name
    name: "PdfOrder",
    // ===Props passed to component
    props: ['order_id'],
    // ===Components used by this component
    components: {
    	PdfView,
      OrderCc,
      EscapeRequest,
      ArtpackRequest,
      EmbroideryRequest,
      ComponentRequest,
      HeatSealRequest,
      AdobePdfViewer
    },
    // ====component Data properties
    data(){
        return{
        	data: null,
          pdfs: [],
          form: null,
          current: null,
          currentIndex: 0,
          currentLoading: false,
          generateType: '',
          generateGroup: '',
          generateModal: false,
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
    	this.getOrder()
    	// this.getPdfData(this.form)
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
	span.cls_002{font-family:Arial,serif;font-size:9.1px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_002{font-family:Arial,serif;font-size:9.1px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	span.cls_003{font-family:Arial,serif;font-size:11.3px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_003{font-family:Arial,serif;font-size:11.3px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	span.cls_004{font-family:Arial,serif;font-size:8.3px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_004{font-family:Arial,serif;font-size:8.3px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	span.cls_005{font-family:Arial,serif;font-size:15.1px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_005{font-family:Arial,serif;font-size:15.1px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	span.cls_006{font-family:Arial,serif;font-size:10.0px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_006{font-family:Arial,serif;font-size:10.0px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	span.cls_007{font-family:Arial,serif;font-size:9.8px;color:rgb(0,0,0);font-weight:bold;font-style:normal;text-decoration: none}
	div.cls_007{font-family:Arial,serif;font-size:9.8px;color:rgb(0,0,0);font-weight:bold;font-style:normal;text-decoration: none}
	span.cls_008{font-family:Arial,serif;font-size:6.0px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_008{font-family:Arial,serif;font-size:6.0px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}

</style>
